import { Row, Col, Collapse, Typography } from "antd";
import colors from "constants/colors";
import { Link } from "react-router-dom";

const { Title, Text } = Typography;
const { Panel } = Collapse;

const FAQSection: React.FC = () => {
  return (
    <Row
      justify="center"
      align="top"
      style={{
        padding: "8rem 2em 0 2rem",
      }}
    >
      <Col xs={24} sm={24} md={20} lg={20}>
        <Row justify="space-between" align="middle" style={{ marginBottom: "1.5rem" }}>
          <Title level={1} style={{ color: "var(--bindeleddet-color)", marginBottom: 0 }}>
            Noe du lurer på?
          </Title>
          <Link to="/contact-us/">
            <Text style={{ color: colors.secondary, fontWeight: "bold" }}> Se mer &gt;</Text>
          </Link>
        </Row>
        <Collapse
          accordion
          bordered={false}
          expandIconPosition="end"
          style={{
            fontSize: "16px",
          }}
        >
          <Panel
            header="Hvor lenge før åpner påmeldingen for et arrangement?"
            key="1"
            style={{
              borderTop: `1px solid var(--divider-color)`,
              borderBottom: `1px solid var(--divider-color)`,
            }}
          >
            <Text>
              Påmelding til arrangementene åpner klokken 12.00, 5 dager før arrangementsdagen om ikke annet er opplyst i
              arrangementsbeskrivelsen.
            </Text>
          </Panel>
          <Panel
            header="Hvordan kan jeg opprette en stillingsannonse for min bedrift?"
            key="2"
            style={{
              borderBottom: `1px solid var(--divider-color)`,
            }}
          >
            <Text>
              Dere kan helt gratis opprette en stillingsannonse ved å gå inn på &quot;Min side&quot; øverst i høyre
              hjørne, og deretter trykke &quot;Opprett stillingsannonse&quot;. Merk at dere må være registrert og
              innlogget som en bedrift for å opprette en annonse.
            </Text>
          </Panel>
          <Panel
            header="Hvordan kan dere promotere min bedrift på deres sosiale medier?"
            key="3"
            style={{
              borderBottom: `1px solid var(--divider-color)`,
            }}
          >
            <Text>
              Vi kan promotere din bedrift gjennom innlegg, stories og annonser på våre sosiale medier. Kontakt oss for
              mer informasjon.
            </Text>
          </Panel>
        </Collapse>
      </Col>
    </Row>
  );
};

export default FAQSection;
